module.exports = __webpack_public_path__ + "media/images/icons/payment-methods/discover-4a058cbf84234bfc46c1a814abbbe183.svg";